var items = {
  "block.minecraft.air": "zrak",
  "block.minecraft.stone": "kamen",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "brušen granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "brušen diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "brušen andezit",
  "block.minecraft.grass_block": "kocka trave",
  "block.minecraft.dirt": "zemlja",
  "block.minecraft.coarse_dirt": "groba zemlja",
  "block.minecraft.podzol": "podrast",
  "block.minecraft.crimson_nylium": "krvaveč nilij",
  "block.minecraft.warped_nylium": "popačen nilij",
  "block.minecraft.cobblestone": "tlakovec",
  "block.minecraft.oak_planks": "hrastove deske",
  "block.minecraft.spruce_planks": "smrekove deske",
  "block.minecraft.birch_planks": "brezove deske",
  "block.minecraft.jungle_planks": "džungelske deske",
  "block.minecraft.acacia_planks": "akacijeve deske",
  "block.minecraft.dark_oak_planks": "temne hrastove deske",
  "block.minecraft.crimson_planks": "krvaveče deske",
  "block.minecraft.warped_planks": "popačene deske",
  "block.minecraft.oak_sapling": "hrastova sadika",
  "block.minecraft.spruce_sapling": "smrekova sadika",
  "block.minecraft.birch_sapling": "brezova sadika",
  "block.minecraft.jungle_sapling": "džungelska sadika",
  "block.minecraft.acacia_sapling": "akacijeva sadika",
  "block.minecraft.dark_oak_sapling": "temna hrastova sadika",
  "block.minecraft.bedrock": "trda skala",
  "block.minecraft.sand": "pesek",
  "block.minecraft.red_sand": "rdeči pesek",
  "block.minecraft.gravel": "gramoz",
  "block.minecraft.gold_ore": "zlata ruda",
  "block.minecraft.iron_ore": "železova ruda",
  "block.minecraft.coal_ore": "premogova ruda",
  "block.minecraft.nether_gold_ore": "netherna zlata ruda",
  "block.minecraft.oak_log": "hrastov hlod",
  "block.minecraft.spruce_log": "smrekov hlod",
  "block.minecraft.birch_log": "brezov hlod",
  "block.minecraft.jungle_log": "džungelski hlod",
  "block.minecraft.acacia_log": "akacijev hlod",
  "block.minecraft.dark_oak_log": "temen hrastov hlod",
  "block.minecraft.crimson_stem": "krvaveč bet",
  "block.minecraft.warped_stem": "popačen bet",
  "block.minecraft.stripped_oak_log": "olupljen hrastov hlod",
  "block.minecraft.stripped_spruce_log": "olupljen smrekov hlod",
  "block.minecraft.stripped_birch_log": "olupljen brezov hlod",
  "block.minecraft.stripped_jungle_log": "olupljen džungelski hlod",
  "block.minecraft.stripped_acacia_log": "olupljen akacijev hlod",
  "block.minecraft.stripped_dark_oak_log": "olupljen temno hrastov hlod",
  "block.minecraft.stripped_crimson_stem": "olupljen krvaveč bet",
  "block.minecraft.stripped_warped_stem": "olupljen popačen bet",
  "block.minecraft.stripped_oak_wood": "olupljen hrastov les",
  "block.minecraft.stripped_spruce_wood": "olupljen smrekov les",
  "block.minecraft.stripped_birch_wood": "olupljen brezov les",
  "block.minecraft.stripped_jungle_wood": "olupljen džungelski les",
  "block.minecraft.stripped_acacia_wood": "olupljen akacijev les",
  "block.minecraft.stripped_dark_oak_wood": "olupljen temen hrastov les",
  "block.minecraft.stripped_crimson_hyphae": "olupljene krvaveče hife",
  "block.minecraft.stripped_warped_hyphae": "olupljene popačene hife",
  "block.minecraft.oak_wood": "hrastov les",
  "block.minecraft.spruce_wood": "smrekov les",
  "block.minecraft.birch_wood": "brezov les",
  "block.minecraft.jungle_wood": "džungelski les",
  "block.minecraft.acacia_wood": "akacijev les",
  "block.minecraft.dark_oak_wood": "temen hrastov les",
  "block.minecraft.crimson_hyphae": "krvaveče hife",
  "block.minecraft.warped_hyphae": "popačene hife",
  "block.minecraft.oak_leaves": "hrastovo listje",
  "block.minecraft.spruce_leaves": "smrekovo listje",
  "block.minecraft.birch_leaves": "brezovo listje",
  "block.minecraft.jungle_leaves": "džungelsko listje",
  "block.minecraft.acacia_leaves": "akacijevo listje",
  "block.minecraft.dark_oak_leaves": "temno hrastovo listje",
  "block.minecraft.sponge": "spužva",
  "block.minecraft.wet_sponge": "mokra spužva",
  "block.minecraft.glass": "steklo",
  "block.minecraft.lapis_ore": "ruda lazurnega kamna",
  "block.minecraft.lapis_block": "kocka lazurnega kamna",
  "block.minecraft.dispenser": "izstreljevalec",
  "block.minecraft.sandstone": "peščenjak",
  "block.minecraft.chiseled_sandstone": "izklesani peščenjak",
  "block.minecraft.cut_sandstone": "rezan peščenjak",
  "block.minecraft.note_block": "glasbena kocka",
  "block.minecraft.powered_rail": "električna tirnica",
  "block.minecraft.detector_rail": "zaznavna tirnica",
  "block.minecraft.sticky_piston": "lepljiv bat",
  "block.minecraft.cobweb": "pajčevina",
  "block.minecraft.grass": "trava",
  "block.minecraft.fern": "praprot",
  "block.minecraft.dead_bush": "mrtev grmiček",
  "block.minecraft.seagrass": "morska trava",
  "block.minecraft.sea_pickle": "morska kumara",
  "block.minecraft.piston": "bat",
  "block.minecraft.white_wool": "bela volna",
  "block.minecraft.orange_wool": "oranžna volna",
  "block.minecraft.magenta_wool": "škrlatna volna",
  "block.minecraft.light_blue_wool": "svetlo modra volna",
  "block.minecraft.yellow_wool": "rumena volna",
  "block.minecraft.lime_wool": "svetlo zelena volna",
  "block.minecraft.pink_wool": "roza volna",
  "block.minecraft.gray_wool": "siva volna",
  "block.minecraft.light_gray_wool": "svetlo siva volna",
  "block.minecraft.cyan_wool": "turkizna volna",
  "block.minecraft.purple_wool": "vijolična volna",
  "block.minecraft.blue_wool": "modra volna",
  "block.minecraft.brown_wool": "rjava volna",
  "block.minecraft.green_wool": "zelena volna",
  "block.minecraft.red_wool": "rdeča volna",
  "block.minecraft.black_wool": "črna volna",
  "block.minecraft.dandelion": "regrat",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "modra orhideja",
  "block.minecraft.allium": "luk",
  "block.minecraft.azure_bluet": "vijolice",
  "block.minecraft.red_tulip": "rdeči tulipan",
  "block.minecraft.orange_tulip": "oranžni tulipan",
  "block.minecraft.white_tulip": "beli tulipan",
  "block.minecraft.pink_tulip": "roza tulipan",
  "block.minecraft.oxeye_daisy": "marjetica",
  "block.minecraft.cornflower": "plavica",
  "block.minecraft.lily_of_the_valley": "šmarnica",
  "block.minecraft.wither_rose": "wither vrtnica",
  "block.minecraft.brown_mushroom": "goban",
  "block.minecraft.red_mushroom": "golobica",
  "block.minecraft.crimson_fungus": "krvaveča goba",
  "block.minecraft.warped_fungus": "popačena goba",
  "block.minecraft.crimson_roots": "krvaveče korenine",
  "block.minecraft.warped_roots": "popačene korenine",
  "block.minecraft.nether_sprouts": "peklenski kalčki",
  "block.minecraft.weeping_vines": "javkajoče ovijalke",
  "block.minecraft.twisting_vines": "divje plezalke",
  "block.minecraft.sugar_cane": "sladkorni trs",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "kocka zlata",
  "block.minecraft.iron_block": "kocka železa",
  "block.minecraft.oak_slab": "hrastova plošča",
  "block.minecraft.spruce_slab": "smrekova plošča",
  "block.minecraft.birch_slab": "brezova plošča",
  "block.minecraft.jungle_slab": "džungelska plošča",
  "block.minecraft.acacia_slab": "akacijeva plošča",
  "block.minecraft.dark_oak_slab": "temna hrastova plošča",
  "block.minecraft.crimson_slab": "krvaveča plošča",
  "block.minecraft.warped_slab": "popačena plošča",
  "block.minecraft.stone_slab": "kamnita plošča",
  "block.minecraft.smooth_stone_slab": "gladka kamnita plošča",
  "block.minecraft.sandstone_slab": "peščenjakova plošča",
  "block.minecraft.cut_sandstone_slab": "rezana peščenjakova plošča",
  "block.minecraft.petrified_oak_slab": "okamenela hrastova plošča",
  "block.minecraft.cobblestone_slab": "tlakovana plošča",
  "block.minecraft.brick_slab": "opečnata plošča",
  "block.minecraft.stone_brick_slab": "kamnita opečnata plošča",
  "block.minecraft.nether_brick_slab": "netherna opečnata plošča",
  "block.minecraft.quartz_slab": "plošča nethernega kremena",
  "block.minecraft.red_sandstone_slab": "rdeča peščenjakova plošča",
  "block.minecraft.cut_red_sandstone_slab": "rezana rdeča peščenjakova plošča",
  "block.minecraft.purpur_slab": "purpurna plošča",
  "block.minecraft.prismarine_slab": "plošča morske prizme",
  "block.minecraft.prismarine_brick_slab": "plošča opeke morske prizme",
  "block.minecraft.dark_prismarine_slab": "plošča temne morske prizme",
  "block.minecraft.smooth_quartz": "gladka kocka kremenovega kamna",
  "block.minecraft.smooth_red_sandstone": "gladek rdeči peščenjak",
  "block.minecraft.smooth_sandstone": "gladek peščenjak",
  "block.minecraft.smooth_stone": "kamen",
  "block.minecraft.bricks": "opeke",
  "block.minecraft.tnt": "dinamit",
  "block.minecraft.bookshelf": "knjižna polica",
  "block.minecraft.mossy_cobblestone": "poraščen tlakovec",
  "block.minecraft.obsidian": "vulkanski kamen",
  "block.minecraft.torch": "bakla",
  "block.minecraft.end_rod": "end palica",
  "block.minecraft.chorus_plant": "refrenska rastlina",
  "block.minecraft.chorus_flower": "refrenska roža",
  "block.minecraft.purpur_block": "purpurna kocka",
  "block.minecraft.purpur_pillar": "purpurni steber",
  "block.minecraft.purpur_stairs": "purpurne stopnice",
  "block.minecraft.spawner": "izvir pošasti",
  "block.minecraft.oak_stairs": "hrastove stopnice",
  "block.minecraft.chest": "skrinja",
  "block.minecraft.diamond_ore": "diamantna ruda",
  "block.minecraft.diamond_block": "kocka diamanta",
  "block.minecraft.crafting_table": "delovna miza",
  "block.minecraft.farmland": "zorana zemlja",
  "block.minecraft.furnace": "peč",
  "block.minecraft.ladder": "lestev",
  "block.minecraft.rail": "tirnica",
  "block.minecraft.cobblestone_stairs": "tlakovane stopnice",
  "block.minecraft.lever": "ročica",
  "block.minecraft.stone_pressure_plate": "kamnita zaznavna plošča",
  "block.minecraft.oak_pressure_plate": "hrastova zaznavna plošča",
  "block.minecraft.spruce_pressure_plate": "smrekova zaznavna plošča",
  "block.minecraft.birch_pressure_plate": "brezova zaznavna plošča",
  "block.minecraft.jungle_pressure_plate": "džungelska zaznavna plošča",
  "block.minecraft.acacia_pressure_plate": "akacijeva zaznavna plošča",
  "block.minecraft.dark_oak_pressure_plate": "temna hrastova zaznavna plošča",
  "block.minecraft.crimson_pressure_plate": "krvaveča zaznavna plošča",
  "block.minecraft.warped_pressure_plate": "popačena zaznavna plošča",
  "block.minecraft.polished_blackstone_pressure_plate": "brušena črna kamnita zaznavna plošča",
  "block.minecraft.redstone_ore": "redstone ruda",
  "block.minecraft.redstone_torch": "redstone bakla",
  "block.minecraft.snow": "sneg",
  "block.minecraft.ice": "led",
  "block.minecraft.snow_block": "kocka snega",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "glina",
  "block.minecraft.jukebox": "gramofon",
  "block.minecraft.oak_fence": "hrastova ograja",
  "block.minecraft.spruce_fence": "smrekova ograja",
  "block.minecraft.birch_fence": "brezova ograja",
  "block.minecraft.jungle_fence": "džungelska ograja",
  "block.minecraft.acacia_fence": "akacijeva ograja",
  "block.minecraft.dark_oak_fence": "temna hrastova ograja",
  "block.minecraft.crimson_fence": "krvaveča ograja",
  "block.minecraft.warped_fence": "popačena ograja",
  "block.minecraft.pumpkin": "buča",
  "block.minecraft.carved_pumpkin": "izrezana buča",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "pesek duš",
  "block.minecraft.soul_soil": "zemlja duš",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "brušen bazalt",
  "block.minecraft.soul_torch": "bakla duš",
  "block.minecraft.glowstone": "svetleči kamen",
  "block.minecraft.jack_o_lantern": "svetleča buča",
  "block.minecraft.oak_trapdoor": "hrastova loputa",
  "block.minecraft.spruce_trapdoor": "smrekova loputa",
  "block.minecraft.birch_trapdoor": "brezova loputa",
  "block.minecraft.jungle_trapdoor": "džungelska loputa",
  "block.minecraft.acacia_trapdoor": "akacijeva loputa",
  "block.minecraft.dark_oak_trapdoor": "temna hrastova loputa",
  "block.minecraft.crimson_trapdoor": "krvaveča loputa",
  "block.minecraft.warped_trapdoor": "popačena loputa",
  "block.minecraft.infested_stone": "okužen kamen",
  "block.minecraft.infested_cobblestone": "okužen tlakovec",
  "block.minecraft.infested_stone_bricks": "okužene kamnite opeke",
  "block.minecraft.infested_mossy_stone_bricks": "okužene poraščene kamnite opeke",
  "block.minecraft.infested_cracked_stone_bricks": "okužene razpokane kamnite opeke",
  "block.minecraft.infested_chiseled_stone_bricks": "okužene izklesane kamnite opeke",
  "block.minecraft.stone_bricks": "kamnite opeke",
  "block.minecraft.mossy_stone_bricks": "poraščene kamnite opeke",
  "block.minecraft.cracked_stone_bricks": "razpokane kamnite opeke",
  "block.minecraft.chiseled_stone_bricks": "izklesane kamnite opeke",
  "block.minecraft.brown_mushroom_block": "kocka gobana",
  "block.minecraft.red_mushroom_block": "kocka golobice",
  "block.minecraft.mushroom_stem": "gobji bet",
  "block.minecraft.iron_bars": "železne rešetke",
  "block.minecraft.chain": "veriga",
  "block.minecraft.glass_pane": "vitraž",
  "block.minecraft.melon": "lubenica",
  "block.minecraft.vine": "ovijalke",
  "block.minecraft.oak_fence_gate": "hrastova ograjna vrata",
  "block.minecraft.spruce_fence_gate": "smrekova ograjna vrata",
  "block.minecraft.birch_fence_gate": "brezova ograjna vrata",
  "block.minecraft.jungle_fence_gate": "džungelska ograjna vrata",
  "block.minecraft.acacia_fence_gate": "akacijeva ograjna vrata",
  "block.minecraft.dark_oak_fence_gate": "temna hrastova ograjna vrata",
  "block.minecraft.crimson_fence_gate": "krvaveča ograjna vrata",
  "block.minecraft.warped_fence_gate": "popačena ograjna vrata",
  "block.minecraft.brick_stairs": "opečnate stopnice",
  "block.minecraft.stone_brick_stairs": "kamnite opečnate stopnice",
  "block.minecraft.mycelium": "micelij",
  "block.minecraft.lily_pad": "lokvanj",
  "block.minecraft.nether_bricks": "netherne opeke",
  "block.minecraft.cracked_nether_bricks": "razpokane peklenske opeke",
  "block.minecraft.chiseled_nether_bricks": "izklesane peklenske opeke",
  "block.minecraft.nether_brick_fence": "netherna opečnata ograja",
  "block.minecraft.nether_brick_stairs": "netherne opečnate stopnice",
  "block.minecraft.enchanting_table": "čarobna miza",
  "block.minecraft.end_portal_frame": "okvir portala za end",
  "block.minecraft.end_stone": "end kamen",
  "block.minecraft.end_stone_bricks": "end kamnite opeke",
  "block.minecraft.dragon_egg": "zmajevo jajce",
  "block.minecraft.redstone_lamp": "redstone svetilka",
  "block.minecraft.sandstone_stairs": "peščenjakove stopnice",
  "block.minecraft.emerald_ore": "smaragdova ruda",
  "block.minecraft.ender_chest": "ender skrinja",
  "block.minecraft.tripwire_hook": "kavelj žične pasti",
  "block.minecraft.emerald_block": "kocka smaragda",
  "block.minecraft.spruce_stairs": "smrekove stopnice",
  "block.minecraft.birch_stairs": "brezove stopnice",
  "block.minecraft.jungle_stairs": "džungelske stopnice",
  "block.minecraft.crimson_stairs": "krvaveče stopnice",
  "block.minecraft.warped_stairs": "popačene stopnice",
  "block.minecraft.command_block": "ukazna kocka",
  "block.minecraft.beacon": "svetilnik",
  "block.minecraft.cobblestone_wall": "tlakovan zid",
  "block.minecraft.mossy_cobblestone_wall": "poraščen tlakovan zid",
  "block.minecraft.brick_wall": "opečnat zid",
  "block.minecraft.prismarine_wall": "zid morske prizme",
  "block.minecraft.red_sandstone_wall": "rdeči peščenjakov zid",
  "block.minecraft.mossy_stone_brick_wall": "poraščen kamnit opečnat zid",
  "block.minecraft.granite_wall": "granitni zid",
  "block.minecraft.stone_brick_wall": "kamnit opečnat zid",
  "block.minecraft.nether_brick_wall": "netherni opečnati zid",
  "block.minecraft.andesite_wall": "andezitni zid",
  "block.minecraft.red_nether_brick_wall": "rdeči netherni opečnati zid",
  "block.minecraft.sandstone_wall": "peščenjakov zid",
  "block.minecraft.end_stone_brick_wall": "end kamniti opečnati zid",
  "block.minecraft.diorite_wall": "dioritni zid",
  "block.minecraft.blackstone_wall": "črni kamnit zid",
  "block.minecraft.polished_blackstone_wall": "brušen črni kamnit zid",
  "block.minecraft.polished_blackstone_brick_wall": "brušen črni kamnit opečnat zid",
  "block.minecraft.stone_button": "kamnit gumb",
  "block.minecraft.oak_button": "hrastov gumb",
  "block.minecraft.spruce_button": "smrekov gumb",
  "block.minecraft.birch_button": "brezov gumb",
  "block.minecraft.jungle_button": "džungelski gumb",
  "block.minecraft.acacia_button": "akacijev gumb",
  "block.minecraft.dark_oak_button": "temen hrastov gumb",
  "block.minecraft.crimson_button": "krvaveč gumb",
  "block.minecraft.warped_button": "popačen gumb",
  "block.minecraft.polished_blackstone_button": "brušen črni kamnit gumb",
  "block.minecraft.anvil": "nakovalo",
  "block.minecraft.chipped_anvil": "okrušeno nakovalo",
  "block.minecraft.damaged_anvil": "poškodovano nakovalo",
  "block.minecraft.trapped_chest": "skrinja s pastjo",
  "block.minecraft.light_weighted_pressure_plate": "lažja števna zaznavna plošča",
  "block.minecraft.heavy_weighted_pressure_plate": "težja števna zaznavna plošča",
  "block.minecraft.daylight_detector": "senzor dnevne svetlobe",
  "block.minecraft.redstone_block": "kocka redstona",
  "block.minecraft.nether_quartz_ore": "ruda nethernega kremena",
  "block.minecraft.hopper": "lijak",
  "block.minecraft.chiseled_quartz_block": "izklesan netherni kremen",
  "block.minecraft.quartz_block": "kocka nethernega kremena",
  "block.minecraft.quartz_bricks": "kremenaste opeke",
  "block.minecraft.quartz_pillar": "steber nethernega kremena",
  "block.minecraft.quartz_stairs": "stopnice nethernega kremena",
  "block.minecraft.activator_rail": "aktivacijska tirnica",
  "block.minecraft.dropper": "delilnik",
  "block.minecraft.white_terracotta": "bela terakota",
  "block.minecraft.orange_terracotta": "oranžna terakota",
  "block.minecraft.magenta_terracotta": "škrlatna terakota",
  "block.minecraft.light_blue_terracotta": "svetlo modra terakota",
  "block.minecraft.yellow_terracotta": "rumena terakota",
  "block.minecraft.lime_terracotta": "svetlo zelena terakota",
  "block.minecraft.pink_terracotta": "roza terakota",
  "block.minecraft.gray_terracotta": "siva terakota",
  "block.minecraft.light_gray_terracotta": "svetlo siva terakota",
  "block.minecraft.cyan_terracotta": "turkizna terakota",
  "block.minecraft.purple_terracotta": "vijolična terakota",
  "block.minecraft.blue_terracotta": "modra terakota",
  "block.minecraft.brown_terracotta": "rjava terakota",
  "block.minecraft.green_terracotta": "zelena terakota",
  "block.minecraft.red_terracotta": "rdeča terakota",
  "block.minecraft.black_terracotta": "črna terakota",
  "block.minecraft.barrier": "nevidna pregrada",
  "block.minecraft.iron_trapdoor": "železna loputa",
  "block.minecraft.hay_block": "bala sena",
  "block.minecraft.white_carpet": "bela preproga",
  "block.minecraft.orange_carpet": "oranžna preproga",
  "block.minecraft.magenta_carpet": "škrlatna preproga",
  "block.minecraft.light_blue_carpet": "svetlo modra preproga",
  "block.minecraft.yellow_carpet": "rumena preproga",
  "block.minecraft.lime_carpet": "svetlo zelena preproga",
  "block.minecraft.pink_carpet": "roza preproga",
  "block.minecraft.gray_carpet": "siva preproga",
  "block.minecraft.light_gray_carpet": "svetlo siva preproga",
  "block.minecraft.cyan_carpet": "turkizna preproga",
  "block.minecraft.purple_carpet": "vijolična preproga",
  "block.minecraft.blue_carpet": "modra preproga",
  "block.minecraft.brown_carpet": "rjava preproga",
  "block.minecraft.green_carpet": "zelena preproga",
  "block.minecraft.red_carpet": "rdeča preproga",
  "block.minecraft.black_carpet": "črna preproga",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "kocka premoga",
  "block.minecraft.packed_ice": "strnjen led",
  "block.minecraft.acacia_stairs": "akacijeve stopnice",
  "block.minecraft.dark_oak_stairs": "temne hrastove stopnice",
  "block.minecraft.slime_block": "kocka sluzi",
  "block.minecraft.grass_path": "travna pot",
  "block.minecraft.sunflower": "sončnica",
  "block.minecraft.lilac": "španski bezeg",
  "block.minecraft.rose_bush": "grm vrtnic",
  "block.minecraft.peony": "potonika",
  "block.minecraft.tall_grass": "visoka trava",
  "block.minecraft.large_fern": "veliki praprot",
  "block.minecraft.white_stained_glass": "belo obarvano steklo",
  "block.minecraft.orange_stained_glass": "oranžno obarvano steklo",
  "block.minecraft.magenta_stained_glass": "škrlantno obarvano steklo",
  "block.minecraft.light_blue_stained_glass": "svetlo modro obarvano steklo",
  "block.minecraft.yellow_stained_glass": "rumeno obarvano steklo",
  "block.minecraft.lime_stained_glass": "svetlo zeleno obarvano steklo",
  "block.minecraft.pink_stained_glass": "roza obarvano steklo",
  "block.minecraft.gray_stained_glass": "sivo obarvano steklo",
  "block.minecraft.light_gray_stained_glass": "svetlo sivo obarvano steklo",
  "block.minecraft.cyan_stained_glass": "turkizno obarvano steklo",
  "block.minecraft.purple_stained_glass": "vijolično obarvano steklo",
  "block.minecraft.blue_stained_glass": "modro obarvano steklo",
  "block.minecraft.brown_stained_glass": "rjavo obarvano steklo",
  "block.minecraft.green_stained_glass": "zeleno obarvano steklo",
  "block.minecraft.red_stained_glass": "rdeče obarvano steklo",
  "block.minecraft.black_stained_glass": "črno obarvano steklo",
  "block.minecraft.white_stained_glass_pane": "belo obarvan vitraž",
  "block.minecraft.orange_stained_glass_pane": "oranžno obarvan vitraž",
  "block.minecraft.magenta_stained_glass_pane": "škrlantno obarvan vitraž",
  "block.minecraft.light_blue_stained_glass_pane": "svetlo modro obarvan vitraž",
  "block.minecraft.yellow_stained_glass_pane": "rumeno obarvan vitraž",
  "block.minecraft.lime_stained_glass_pane": "svetlo zeleno obarvan vitraž",
  "block.minecraft.pink_stained_glass_pane": "roza obarvan vitraž",
  "block.minecraft.gray_stained_glass_pane": "sivo obarvan vitraž",
  "block.minecraft.light_gray_stained_glass_pane": "svetlo sivo obarvan vitraž",
  "block.minecraft.cyan_stained_glass_pane": "turkizno obarvan vitraž",
  "block.minecraft.purple_stained_glass_pane": "vijolično obarvan vitraž",
  "block.minecraft.blue_stained_glass_pane": "modro obarvan vitraž",
  "block.minecraft.brown_stained_glass_pane": "rjavo obarvan vitraž",
  "block.minecraft.green_stained_glass_pane": "zeleno obarvan vitraž",
  "block.minecraft.red_stained_glass_pane": "rdeče pobarvan vitraž",
  "block.minecraft.black_stained_glass_pane": "črno obarvan vitraž",
  "block.minecraft.prismarine": "morska prizma",
  "block.minecraft.prismarine_bricks": "opeke morske prizme",
  "block.minecraft.dark_prismarine": "temna morska prizma",
  "block.minecraft.prismarine_stairs": "stopnice morske prizme",
  "block.minecraft.prismarine_brick_stairs": "stopnice opeke morske prizme",
  "block.minecraft.dark_prismarine_stairs": "stopnice temne morske prizme",
  "block.minecraft.sea_lantern": "morska svetilka",
  "block.minecraft.red_sandstone": "rdeči peščenjak",
  "block.minecraft.chiseled_red_sandstone": "izklesani rdeči peščenjak",
  "block.minecraft.cut_red_sandstone": "rezan rdeči peščenjak",
  "block.minecraft.red_sandstone_stairs": "rdeče peščenjakove stopnice",
  "block.minecraft.repeating_command_block": "ponavljanje ukazne kocke",
  "block.minecraft.chain_command_block": "veriga ukazne kocke",
  "block.minecraft.magma_block": "kocka magme",
  "block.minecraft.nether_wart_block": "kocka nethernih bradavic",
  "block.minecraft.warped_wart_block": "kocka popačenih bradavic",
  "block.minecraft.red_nether_bricks": "rdeča netherna opeka",
  "block.minecraft.bone_block": "kostna kocka",
  "block.minecraft.structure_void": "strukturna praznina",
  "block.minecraft.observer": "opazovalec",
  "block.minecraft.shulker_box": "shulker skrinja",
  "block.minecraft.white_shulker_box": "bela shulker skrinja",
  "block.minecraft.orange_shulker_box": "oranžna shulker skrinja",
  "block.minecraft.magenta_shulker_box": "škrlatna shulker skrinja",
  "block.minecraft.light_blue_shulker_box": "svetlo modra shulker skrinja",
  "block.minecraft.yellow_shulker_box": "rumena shulker skrinja",
  "block.minecraft.lime_shulker_box": "svetlo zelena shulker skrinja",
  "block.minecraft.pink_shulker_box": "roza shulker skrinja",
  "block.minecraft.gray_shulker_box": "siva shulker skrinja",
  "block.minecraft.light_gray_shulker_box": "svetlo siva shulker skrinja",
  "block.minecraft.cyan_shulker_box": "turkizna shulker skrinja",
  "block.minecraft.purple_shulker_box": "vijolična shulker skrinja",
  "block.minecraft.blue_shulker_box": "modra shulker skrinja",
  "block.minecraft.brown_shulker_box": "rjava shulker skrinja",
  "block.minecraft.green_shulker_box": "zelena shulker skrinja",
  "block.minecraft.red_shulker_box": "rdeča shulker skrinja",
  "block.minecraft.black_shulker_box": "črna shulker skrinja",
  "block.minecraft.white_glazed_terracotta": "bela glazirana terakota",
  "block.minecraft.orange_glazed_terracotta": "oranžna glazirana terakota",
  "block.minecraft.magenta_glazed_terracotta": "škrlatna glazirana terakota",
  "block.minecraft.light_blue_glazed_terracotta": "svetlo modra glazirana terakota",
  "block.minecraft.yellow_glazed_terracotta": "rumena glazirana terakota",
  "block.minecraft.lime_glazed_terracotta": "svetlo zelena glazirana terakota",
  "block.minecraft.pink_glazed_terracotta": "roza glazirana terakota",
  "block.minecraft.gray_glazed_terracotta": "siva glazirana terakota",
  "block.minecraft.light_gray_glazed_terracotta": "svetlo siva glazirana terakota",
  "block.minecraft.cyan_glazed_terracotta": "turkizna glazirana terakota",
  "block.minecraft.purple_glazed_terracotta": "vijolična glazirana terakota",
  "block.minecraft.blue_glazed_terracotta": "modra glazirana terakota",
  "block.minecraft.brown_glazed_terracotta": "rjava glazirana terakota",
  "block.minecraft.green_glazed_terracotta": "zelena glazirana terakota",
  "block.minecraft.red_glazed_terracotta": "rdeča glazirana terakota",
  "block.minecraft.black_glazed_terracotta": "črna glazirana terakota",
  "block.minecraft.white_concrete": "bel beton",
  "block.minecraft.orange_concrete": "oranžen beton",
  "block.minecraft.magenta_concrete": "škrlaten beton",
  "block.minecraft.light_blue_concrete": "svetlo moder beton",
  "block.minecraft.yellow_concrete": "rumen beton",
  "block.minecraft.lime_concrete": "svetlo zelen beton",
  "block.minecraft.pink_concrete": "roza beton",
  "block.minecraft.gray_concrete": "siv beton",
  "block.minecraft.light_gray_concrete": "svetlo siv beton",
  "block.minecraft.cyan_concrete": "turkizen beton",
  "block.minecraft.purple_concrete": "vijoličen beton",
  "block.minecraft.blue_concrete": "moder beton",
  "block.minecraft.brown_concrete": "rjav beton",
  "block.minecraft.green_concrete": "zelen beton",
  "block.minecraft.red_concrete": "rdeč beton",
  "block.minecraft.black_concrete": "črn beton",
  "block.minecraft.white_concrete_powder": "bel cement",
  "block.minecraft.orange_concrete_powder": "oranžen cement",
  "block.minecraft.magenta_concrete_powder": "škrlaten cement",
  "block.minecraft.light_blue_concrete_powder": "svetlo moder cement",
  "block.minecraft.yellow_concrete_powder": "rumen cement",
  "block.minecraft.lime_concrete_powder": "svetlo zelen cement",
  "block.minecraft.pink_concrete_powder": "roza cement",
  "block.minecraft.gray_concrete_powder": "siv cement",
  "block.minecraft.light_gray_concrete_powder": "svetlo siv cement",
  "block.minecraft.cyan_concrete_powder": "turkizen cement",
  "block.minecraft.purple_concrete_powder": "vijoličen cement",
  "block.minecraft.blue_concrete_powder": "moder cement",
  "block.minecraft.brown_concrete_powder": "rjav cement",
  "block.minecraft.green_concrete_powder": "zelen cement",
  "block.minecraft.red_concrete_powder": "rdeč cement",
  "block.minecraft.black_concrete_powder": "črn cement",
  "block.minecraft.turtle_egg": "želvino jajce",
  "block.minecraft.dead_tube_coral_block": "kocka mrtve cevaste korale",
  "block.minecraft.dead_brain_coral_block": "kocka mrtve možganske korale",
  "block.minecraft.dead_bubble_coral_block": "kocka mrtve mehurčkaste korale",
  "block.minecraft.dead_fire_coral_block": "kocka mrtve ognjene korale",
  "block.minecraft.dead_horn_coral_block": "kocka mrtve rogovite korale",
  "block.minecraft.tube_coral_block": "kocka cevaste korale",
  "block.minecraft.brain_coral_block": "kocka možganske korale",
  "block.minecraft.bubble_coral_block": "kocka mehurčkaste korale",
  "block.minecraft.fire_coral_block": "kocka ognjene korale",
  "block.minecraft.horn_coral_block": "kocka rogovite korale",
  "block.minecraft.tube_coral": "cevasta korala",
  "block.minecraft.brain_coral": "možganska korala",
  "block.minecraft.bubble_coral": "mehurčkasta korala",
  "block.minecraft.fire_coral": "ognjena korala",
  "block.minecraft.horn_coral": "rogovita korala",
  "block.minecraft.dead_brain_coral": "mrtva možganska korala",
  "block.minecraft.dead_bubble_coral": "mrtva mehurčkasta korala",
  "block.minecraft.dead_fire_coral": "mrtva ognjena korala",
  "block.minecraft.dead_horn_coral": "mrtva rogovita korala",
  "block.minecraft.dead_tube_coral": "mrtva cevasta korala",
  "block.minecraft.tube_coral_fan": "veje cevaste korale",
  "block.minecraft.brain_coral_fan": "veje možganske korale",
  "block.minecraft.bubble_coral_fan": "veje mehurčkaste korale",
  "block.minecraft.fire_coral_fan": "veje ognjene korale",
  "block.minecraft.horn_coral_fan": "veje rogovite korale",
  "block.minecraft.dead_tube_coral_fan": "mrtve veje cevaste korale",
  "block.minecraft.dead_brain_coral_fan": "mrtve veje možganske korale",
  "block.minecraft.dead_bubble_coral_fan": "mrtve veje mehurčkaste korale",
  "block.minecraft.dead_fire_coral_fan": "mrtve veje ognjene korale",
  "block.minecraft.dead_horn_coral_fan": "mrtve veje rogovite korale",
  "block.minecraft.blue_ice": "moder led",
  "block.minecraft.conduit": "konduktor",
  "block.minecraft.polished_granite_stairs": "brušene granitne stopnice",
  "block.minecraft.smooth_red_sandstone_stairs": "gladke rdeče peščenjakove stopnice",
  "block.minecraft.mossy_stone_brick_stairs": "poraščene kamnite opečnate stopnice",
  "block.minecraft.polished_diorite_stairs": "brušene dioritne stopnice",
  "block.minecraft.mossy_cobblestone_stairs": "poraščene tlakovane stopnice",
  "block.minecraft.end_stone_brick_stairs": "end kamnite opečnate stopnice",
  "block.minecraft.stone_stairs": "kamnite stopnice",
  "block.minecraft.smooth_sandstone_stairs": "gladke peščenjakove stopnice",
  "block.minecraft.smooth_quartz_stairs": "stopnice gladkega nethernega kremena",
  "block.minecraft.granite_stairs": "granitne stopnice",
  "block.minecraft.andesite_stairs": "andezitne stopnice",
  "block.minecraft.red_nether_brick_stairs": "rdeče netherne opečnate stopnice",
  "block.minecraft.polished_andesite_stairs": "brušene andezitne stopnice",
  "block.minecraft.diorite_stairs": "dioritne stopnice",
  "block.minecraft.polished_granite_slab": "brušena granitna plošča",
  "block.minecraft.smooth_red_sandstone_slab": "gladka rdeča peščenjakova plošča",
  "block.minecraft.mossy_stone_brick_slab": "poraščena kamnita opečnata plošča",
  "block.minecraft.polished_diorite_slab": "brušena dioritna plošča",
  "block.minecraft.mossy_cobblestone_slab": "poraščena tlakovana plošča",
  "block.minecraft.end_stone_brick_slab": "end kamnita opečnata plošča",
  "block.minecraft.smooth_sandstone_slab": "gladka peščenjakova plošča",
  "block.minecraft.smooth_quartz_slab": "plošča gladkega nethernega kremena",
  "block.minecraft.granite_slab": "granitna plošča",
  "block.minecraft.andesite_slab": "andezitna plošča",
  "block.minecraft.red_nether_brick_slab": "rdeča netherna opečnata plošča",
  "block.minecraft.polished_andesite_slab": "brušena andezitna plošča",
  "block.minecraft.diorite_slab": "dioritna plošča",
  "block.minecraft.scaffolding": "gradbeni oder",
  "block.minecraft.iron_door": "železna vrata",
  "block.minecraft.oak_door": "hrastova vrata",
  "block.minecraft.spruce_door": "smrekova vrata",
  "block.minecraft.birch_door": "brezova vrata",
  "block.minecraft.jungle_door": "džungelska vrata",
  "block.minecraft.acacia_door": "akacijeva vrata",
  "block.minecraft.dark_oak_door": "temna hrastova vrata",
  "block.minecraft.crimson_door": "krvaveča vrata",
  "block.minecraft.warped_door": "popačena vrata",
  "block.minecraft.repeater": "redstone ojačevalec",
  "block.minecraft.comparator": "redstone primerjalnik",
  "block.minecraft.structure_block": "strukturna kocka",
  "block.minecraft.jigsaw": "kos sestavljanke",
  "item.minecraft.turtle_helmet": "želvin oklep□□kadar na glavi:□+2 oklep",
  "item.minecraft.scute": "želvlja luska",
  "item.minecraft.iron_shovel": "železna lopata□□kadar v primarni roki:□+3.5 škoda napada□-3 hitrost napada",
  "item.minecraft.iron_pickaxe": "železen kramp□□kadar v primarni roki:□+3 škoda napada□-2.8 hitrost napada",
  "item.minecraft.iron_axe": "železna sekira□□kadar v primarni roki:□+8 škoda napada□-3.1 hitrost napada",
  "item.minecraft.flint_and_steel": "netilo",
  "item.minecraft.apple": "jabolko",
  "item.minecraft.bow": "lok",
  "item.minecraft.arrow": "puščica",
  "item.minecraft.coal": "premog",
  "item.minecraft.charcoal": "oglje",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "železna palica",
  "item.minecraft.gold_ingot": "zlata palica",
  "item.minecraft.netherite_ingot": "netheritna palica",
  "item.minecraft.netherite_scrap": "košček netherita",
  "item.minecraft.iron_sword": "železen meč□□kadar v primarni roki:□+5 škoda napada□-2.4 hitrost napada",
  "item.minecraft.wooden_sword": "lesen meč□□kadar v primarni roki:□+3 škoda napada□-2.4 hitrost napada",
  "item.minecraft.wooden_shovel": "lesena lopata□□kadar v primarni roki:□+1.5 škoda napada□-3 hitrost napada",
  "item.minecraft.wooden_pickaxe": "lesen kramp□□kadar v primarni roki:□+1 škoda napada□-2.8 hitrost napada",
  "item.minecraft.wooden_axe": "lesena sekira□□kadar v primarni roki:□+6 škoda napada□-3.2 hitrost napada",
  "item.minecraft.stone_sword": "kamnit meč□□kadar v primarni roki:□+4 škoda napada□-2.4 hitrost napada",
  "item.minecraft.stone_shovel": "kamnita lopata□□kadar v primarni roki:□+2.5 škoda napada□-3 hitrost napada",
  "item.minecraft.stone_pickaxe": "kamnit kramp□□kadar v primarni roki:□+2 škoda napada□-2.8 hitrost napada",
  "item.minecraft.stone_axe": "kamnita sekira□□kadar v primarni roki:□+8 škoda napada□-3.2 hitrost napada",
  "item.minecraft.diamond_sword": "diamantni meč□□kadar v primarni roki:□+6 škoda napada□-2.4 hitrost napada",
  "item.minecraft.diamond_shovel": "diamantna lopata□□kadar v primarni roki:□+4.5 škoda napada□-3 hitrost napada",
  "item.minecraft.diamond_pickaxe": "diamanten kramp□□kadar v primarni roki:□+4 škoda napada□-2.8 hitrost napada",
  "item.minecraft.diamond_axe": "diamantna sekira□□kadar v primarni roki:□+8 škoda napada□-3 hitrost napada",
  "item.minecraft.stick": "palica",
  "item.minecraft.bowl": "skleda",
  "item.minecraft.mushroom_stew": "gobova juha",
  "item.minecraft.golden_sword": "zlati meč□□kadar v primarni roki:□+3 škoda napada□-2.4 hitrost napada",
  "item.minecraft.golden_shovel": "zlata lopata□□kadar v primarni roki:□+1.5 škoda napada□-3 hitrost napada",
  "item.minecraft.golden_pickaxe": "zlati kramp□□kadar v primarni roki:□+1 škoda napada□-2.8 hitrost napada",
  "item.minecraft.golden_axe": "zlata sekira□□kadar v primarni roki:□+6 škoda napada□-3 hitrost napada",
  "item.minecraft.netherite_sword": "netheritni meč□□kadar v primarni roki:□+7 škoda napada□-2.4 hitrost napada",
  "item.minecraft.netherite_shovel": "netheritna lopata□□kadar v primarni roki:□+5.5 škoda napada□-3 hitrost napada",
  "item.minecraft.netherite_pickaxe": "netheritni kramp□□kadar v primarni roki:□+5 škoda napada□-2.8 hitrost napada",
  "item.minecraft.netherite_axe": "netheritna sekira□□kadar v primarni roki:□+9 škoda napada□-3 hitrost napada",
  "item.minecraft.string": "vrvica",
  "item.minecraft.feather": "pero",
  "item.minecraft.gunpowder": "smodnik",
  "item.minecraft.wooden_hoe": "lesena motika□□kadar v primarni roki:□-3 hitrost napada",
  "item.minecraft.stone_hoe": "kamnita motika□□kadar v primarni roki:□-2 hitrost napada",
  "item.minecraft.iron_hoe": "železna motika□□kadar v primarni roki:□-1 hitrost napada",
  "item.minecraft.diamond_hoe": "diamantna motika□□kadar v primarni roki:",
  "item.minecraft.golden_hoe": "zlata motika□□kadar v primarni roki:□-3 hitrost napada",
  "item.minecraft.netherite_hoe": "netheritna motika□□kadar v primarni roki:",
  "item.minecraft.wheat_seeds": "pšenična semena",
  "item.minecraft.wheat": "pšenica",
  "item.minecraft.bread": "kruh",
  "item.minecraft.leather_helmet": "usnjena kapa□□kadar na glavi:□+1 oklep",
  "item.minecraft.leather_chestplate": "usnjena tunika□□kadar na telesu:□+3 oklep",
  "item.minecraft.leather_leggings": "usnjene hlače□□kadar na nogah:□+2 oklep",
  "item.minecraft.leather_boots": "usnjeni čevlji□□kadar na stopalih:□+1 oklep",
  "item.minecraft.chainmail_helmet": "verižna čelada□□kadar na glavi:□+2 oklep",
  "item.minecraft.chainmail_chestplate": "verižni prsni oklep□□kadar na telesu:□+5 oklep",
  "item.minecraft.chainmail_leggings": "verižne hlače□□kadar na nogah:□+4 oklep",
  "item.minecraft.chainmail_boots": "verižni čevlji□□kadar na stopalih:□+1 oklep",
  "item.minecraft.iron_helmet": "železna čelada□□kadar na glavi:□+2 oklep",
  "item.minecraft.iron_chestplate": "železni prsni oklep□□kadar na telesu:□+6 oklep",
  "item.minecraft.iron_leggings": "železne hlače□□kadar na nogah:□+5 oklep",
  "item.minecraft.iron_boots": "železni čevlji□□kadar na stopalih:□+2 oklep",
  "item.minecraft.diamond_helmet": "diamantna čelada□□kadar na glavi:□+3 oklep□+2 moč oklepa",
  "item.minecraft.diamond_chestplate": "diamantni prsni oklep□□kadar na telesu:□+8 oklep□+2 moč oklepa",
  "item.minecraft.diamond_leggings": "diamantne hlače□□kadar na nogah:□+6 oklep□+2 moč oklepa",
  "item.minecraft.diamond_boots": "diamantni čevlji□□kadar na stopalih:□+3 oklep□+2 moč oklepa",
  "item.minecraft.golden_helmet": "zlata čelada□□kadar na glavi:□+2 oklep",
  "item.minecraft.golden_chestplate": "zlat prsni oklep□□kadar na telesu:□+5 oklep",
  "item.minecraft.golden_leggings": "zlate hlače□□kadar na nogah:□+3 oklep",
  "item.minecraft.golden_boots": "zlati čevlji□□kadar na stopalih:□+1 oklep",
  "item.minecraft.netherite_helmet": "netheritna čelada□□kadar na glavi:□+3 oklep□+3 moč oklepa□+1 odpornost na odsunek",
  "item.minecraft.netherite_chestplate": "netheritni prsni oklep□□kadar na telesu:□+8 oklep□+3 moč oklepa□+1 odpornost na odsunek",
  "item.minecraft.netherite_leggings": "netheritne hlače□□kadar na nogah:□+6 oklep□+3 moč oklepa□+1 odpornost na odsunek",
  "item.minecraft.netherite_boots": "netheritni čevlji□□kadar na stopalih:□+3 oklep□+3 moč oklepa□+1 odpornost na odsunek",
  "item.minecraft.flint": "kremen",
  "item.minecraft.porkchop": "surova svinjina",
  "item.minecraft.cooked_porkchop": "svinjski zrezek",
  "item.minecraft.painting": "slika",
  "item.minecraft.golden_apple": "zlato jabolko",
  "item.minecraft.enchanted_golden_apple": "začarano zlato jabolko",
  "block.minecraft.oak_sign": "hrastova tabla",
  "block.minecraft.spruce_sign": "smrekova tabla",
  "block.minecraft.birch_sign": "brezova tabla",
  "block.minecraft.jungle_sign": "džungelska tabla",
  "block.minecraft.acacia_sign": "akacijeva tabla",
  "block.minecraft.dark_oak_sign": "temna hrastova tabla",
  "block.minecraft.crimson_sign": "krvaveča tabla",
  "block.minecraft.warped_sign": "popačena tabla",
  "item.minecraft.bucket": "vedro",
  "item.minecraft.water_bucket": "vedro vode",
  "item.minecraft.lava_bucket": "vedro lave",
  "item.minecraft.minecart": "voziček",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "redstone prah",
  "item.minecraft.snowball": "snežena kepa",
  "item.minecraft.oak_boat": "hrastov čoln",
  "item.minecraft.leather": "usnje",
  "item.minecraft.milk_bucket": "vedro mleka",
  "item.minecraft.pufferfish_bucket": "vedro z napihovalko",
  "item.minecraft.salmon_bucket": "vedro s lososom",
  "item.minecraft.cod_bucket": "vedro s trsko",
  "item.minecraft.tropical_fish_bucket": "vedro s tropsko ribo",
  "item.minecraft.brick": "opeka",
  "item.minecraft.clay_ball": "glinena krogla",
  "block.minecraft.dried_kelp_block": "kocka posušene alge",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "knjiga",
  "item.minecraft.slime_ball": "sluzasta krogla",
  "item.minecraft.chest_minecart": "voziček s skrinjo",
  "item.minecraft.furnace_minecart": "voziček s pečjo",
  "item.minecraft.egg": "jajce",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "ribiška palica",
  "item.minecraft.clock": "ura",
  "item.minecraft.glowstone_dust": "prah svetlečega kamna",
  "item.minecraft.cod": "surova trska",
  "item.minecraft.salmon": "surovi losos",
  "item.minecraft.tropical_fish": "tropska riba",
  "item.minecraft.pufferfish": "napihovalka",
  "item.minecraft.cooked_cod": "kuhana trska",
  "item.minecraft.cooked_salmon": "pečen losos",
  "item.minecraft.ink_sac": "tinta",
  "item.minecraft.red_dye": "rdeče barvilo",
  "item.minecraft.green_dye": "zeleno barvilo",
  "item.minecraft.cocoa_beans": "kakavova zrna",
  "item.minecraft.lapis_lazuli": "lazurni kamen",
  "item.minecraft.purple_dye": "vijolično barvilo",
  "item.minecraft.cyan_dye": "turkizno barvilo",
  "item.minecraft.light_gray_dye": "svetlo sivo barvilo",
  "item.minecraft.gray_dye": "sivo barvilo",
  "item.minecraft.pink_dye": "roza barvilo",
  "item.minecraft.lime_dye": "svetlo zeleno barvilo",
  "item.minecraft.yellow_dye": "rumeno barvilo",
  "item.minecraft.light_blue_dye": "svetlo modro barvilo",
  "item.minecraft.magenta_dye": "škrlatno barvilo",
  "item.minecraft.orange_dye": "oranžno barvilo",
  "item.minecraft.bone_meal": "kostna moka",
  "item.minecraft.blue_dye": "modro barvilo",
  "item.minecraft.brown_dye": "rjavo barvilo",
  "item.minecraft.black_dye": "črno barvilo",
  "item.minecraft.white_dye": "belo barvilo",
  "item.minecraft.bone": "kost",
  "item.minecraft.sugar": "sladkor",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "bela postelja",
  "block.minecraft.orange_bed": "oranžna postelja",
  "block.minecraft.magenta_bed": "škrlatna postelja",
  "block.minecraft.light_blue_bed": "svetlo modra postelja",
  "block.minecraft.yellow_bed": "rumena postelja",
  "block.minecraft.lime_bed": "svetlo zelena postelja",
  "block.minecraft.pink_bed": "roza postelja",
  "block.minecraft.gray_bed": "siva postelja",
  "block.minecraft.light_gray_bed": "svetlo siva postelja",
  "block.minecraft.cyan_bed": "turkizna postelja",
  "block.minecraft.purple_bed": "vijolična postelja",
  "block.minecraft.blue_bed": "modra postelja",
  "block.minecraft.brown_bed": "rjava postelja",
  "block.minecraft.green_bed": "zelena postelja",
  "block.minecraft.red_bed": "rdeča postelja",
  "block.minecraft.black_bed": "črna postelja",
  "item.minecraft.cookie": "piškot",
  "item.minecraft.filled_map": "zemljevid□#0",
  "item.minecraft.shears": "škarje",
  "item.minecraft.melon_slice": "rezina lubenice",
  "item.minecraft.dried_kelp": "posušena alga",
  "item.minecraft.pumpkin_seeds": "bučna semena",
  "item.minecraft.melon_seeds": "semena lubenice",
  "item.minecraft.beef": "surova govedina",
  "item.minecraft.cooked_beef": "goveji zrezek",
  "item.minecraft.chicken": "surov piščanec",
  "item.minecraft.cooked_chicken": "pečen piščanec",
  "item.minecraft.rotten_flesh": "gnilo meso",
  "item.minecraft.ender_pearl": "enderov biser",
  "item.minecraft.blaze_rod": "blaze palica",
  "item.minecraft.ghast_tear": "ghastova solza",
  "item.minecraft.gold_nugget": "zlato zrno",
  "item.minecraft.nether_wart": "netherna bradavica",
  "item.minecraft.potion": "neustvarljiv napoj□brez učinkov",
  "item.minecraft.glass_bottle": "steklenica",
  "item.minecraft.spider_eye": "pajkovo oko",
  "item.minecraft.fermented_spider_eye": "fermentirano pajkovo oko",
  "item.minecraft.blaze_powder": "blaze prah",
  "item.minecraft.magma_cream": "krema iz magme",
  "block.minecraft.brewing_stand": "stojalo za napoje",
  "block.minecraft.cauldron": "kotel",
  "item.minecraft.ender_eye": "enderjevo oko",
  "item.minecraft.glistering_melon_slice": "lesketajoča rezina lubenice",
  "item.minecraft.bat_spawn_egg": "jajček z netopirjem",
  "item.minecraft.bee_spawn_egg": "jajček s čebelo",
  "item.minecraft.blaze_spawn_egg": "jajček z blazom",
  "item.minecraft.cat_spawn_egg": "jajček z mačko",
  "item.minecraft.cave_spider_spawn_egg": "jajček z jamskim pajkom",
  "item.minecraft.chicken_spawn_egg": "jajček s kokošjo",
  "item.minecraft.cod_spawn_egg": "jajček s trsko",
  "item.minecraft.cow_spawn_egg": "jajček s kravo",
  "item.minecraft.creeper_spawn_egg": "jajček s creeperjem",
  "item.minecraft.dolphin_spawn_egg": "jajček z delfinom",
  "item.minecraft.donkey_spawn_egg": "jajček z oslom",
  "item.minecraft.drowned_spawn_egg": "jajček z utopljenim",
  "item.minecraft.elder_guardian_spawn_egg": "jajček z nadvaruhom",
  "item.minecraft.enderman_spawn_egg": "jajček z endermanom",
  "item.minecraft.endermite_spawn_egg": "jajček z endermitom",
  "item.minecraft.evoker_spawn_egg": "jajček s čarodejem",
  "item.minecraft.fox_spawn_egg": "jajček z lisico",
  "item.minecraft.ghast_spawn_egg": "jajček z ghastom",
  "item.minecraft.guardian_spawn_egg": "jajček z varuhom",
  "item.minecraft.hoglin_spawn_egg": "jajček s svinjoglavcem",
  "item.minecraft.horse_spawn_egg": "jajček s konjem",
  "item.minecraft.husk_spawn_egg": "jajček s huskom",
  "item.minecraft.llama_spawn_egg": "jajček z lamo",
  "item.minecraft.magma_cube_spawn_egg": "jajček s kocko magme",
  "item.minecraft.mooshroom_spawn_egg": "jajček z mooshroomom",
  "item.minecraft.mule_spawn_egg": "jajček z mulo",
  "item.minecraft.ocelot_spawn_egg": "jajček z divjo mačko",
  "item.minecraft.panda_spawn_egg": "jajček s pando",
  "item.minecraft.parrot_spawn_egg": "jajček s papigo",
  "item.minecraft.phantom_spawn_egg": "jajček s fantomom",
  "item.minecraft.pig_spawn_egg": "jajček s prašičem",
  "item.minecraft.piglin_spawn_egg": "jajce z pujsoglavcem",
  "item.minecraft.pillager_spawn_egg": "jajček z razbojnikom",
  "item.minecraft.polar_bear_spawn_egg": "jajček s polarnim medvedom",
  "item.minecraft.pufferfish_spawn_egg": "jajček z napihovalko",
  "item.minecraft.rabbit_spawn_egg": "jajček z zajcem",
  "item.minecraft.ravager_spawn_egg": "jajček z uničevalcem",
  "item.minecraft.salmon_spawn_egg": "jajček z lososom",
  "item.minecraft.sheep_spawn_egg": "jajček z ovco",
  "item.minecraft.shulker_spawn_egg": "jajček s shulkerjem",
  "item.minecraft.silverfish_spawn_egg": "jajček s ščetinorepko",
  "item.minecraft.skeleton_spawn_egg": "jajček z okostnjakom",
  "item.minecraft.skeleton_horse_spawn_egg": "jajček z okostnjaškim konjem",
  "item.minecraft.slime_spawn_egg": "jajček s sluzjo",
  "item.minecraft.spider_spawn_egg": "jajček s pajkom",
  "item.minecraft.squid_spawn_egg": "jajček z lignjem",
  "item.minecraft.stray_spawn_egg": "jajček z brezdomcem",
  "item.minecraft.strider_spawn_egg": "jajček z drsalcem",
  "item.minecraft.trader_llama_spawn_egg": "jajček s trgovčevo lamo",
  "item.minecraft.tropical_fish_spawn_egg": "jajček s tropsko ribo",
  "item.minecraft.turtle_spawn_egg": "jajček z želvo",
  "item.minecraft.vex_spawn_egg": "jajček z vexom",
  "item.minecraft.villager_spawn_egg": "jajček z vaščanom",
  "item.minecraft.vindicator_spawn_egg": "jajček z maščevalcem",
  "item.minecraft.wandering_trader_spawn_egg": "jajček s potujočim trgovcem",
  "item.minecraft.witch_spawn_egg": "jajček s čarovnico",
  "item.minecraft.wither_skeleton_spawn_egg": "jajček z wither okostnjakom",
  "item.minecraft.wolf_spawn_egg": "jajček z volkom",
  "item.minecraft.zoglin_spawn_egg": "jajček z zoglinom",
  "item.minecraft.zombie_spawn_egg": "jajček z zombijem",
  "item.minecraft.zombie_horse_spawn_egg": "jajček z zombi konjem",
  "item.minecraft.zombie_villager_spawn_egg": "jajček z zombi vaščanom",
  "item.minecraft.zombified_piglin_spawn_egg": "jajček z zombificiranim pujsoglavcem",
  "item.minecraft.experience_bottle": "steklenica čarovnije",
  "item.minecraft.fire_charge": "ognjeni naboj",
  "item.minecraft.writable_book": "knjiga in pero",
  "item.minecraft.written_book": "napisana knjiga",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "okvir",
  "block.minecraft.flower_pot": "cvetlični lonček",
  "item.minecraft.carrot": "korenje",
  "item.minecraft.potato": "krompir",
  "item.minecraft.baked_potato": "pečen krompir",
  "item.minecraft.poisonous_potato": "strupen krompir",
  "item.minecraft.map": "prazen zemljevid",
  "item.minecraft.golden_carrot": "zlato korenje",
  "block.minecraft.skeleton_skull": "lobanja okostnjaka",
  "block.minecraft.wither_skeleton_skull": "lobanja wither okostnjaka",
  "block.minecraft.player_head": "igralčeva glava",
  "block.minecraft.zombie_head": "zombijeva glava",
  "block.minecraft.creeper_head": "creeperjeva glava",
  "block.minecraft.dragon_head": "zmajeva glava",
  "item.minecraft.carrot_on_a_stick": "korenje na palici",
  "item.minecraft.warped_fungus_on_a_stick": "popačena goba na palici",
  "item.minecraft.nether_star": "netherna zvezda",
  "item.minecraft.pumpkin_pie": "bučna pita",
  "item.minecraft.firework_rocket": "raketa",
  "item.minecraft.firework_star": "zvezda ognjemeta",
  "item.minecraft.enchanted_book": "začarana knjiga",
  "item.minecraft.nether_brick": "netherna opeka",
  "item.minecraft.quartz": "netherni kremen",
  "item.minecraft.tnt_minecart": "voziček z dinamitom",
  "item.minecraft.hopper_minecart": "voziček z lijakom",
  "item.minecraft.prismarine_shard": "košček morske prizme",
  "item.minecraft.prismarine_crystals": "kristali morske prizme",
  "item.minecraft.rabbit": "surov zajec",
  "item.minecraft.cooked_rabbit": "pečen zajec",
  "item.minecraft.rabbit_stew": "zajčja obara",
  "item.minecraft.rabbit_foot": "zajčja taca",
  "item.minecraft.rabbit_hide": "zajčja koža",
  "item.minecraft.armor_stand": "stojalo za oklep",
  "item.minecraft.iron_horse_armor": "železen konjski oklep",
  "item.minecraft.golden_horse_armor": "zlat konjski oklep",
  "item.minecraft.diamond_horse_armor": "diamanten konjski oklep",
  "item.minecraft.leather_horse_armor": "usnjen konjski oklep",
  "item.minecraft.lead": "povodec",
  "item.minecraft.name_tag": "imenska značka",
  "item.minecraft.command_block_minecart": "voziček z ukazno kocko",
  "item.minecraft.mutton": "surova jagnjetina",
  "item.minecraft.cooked_mutton": "pečena jagnjetina",
  "block.minecraft.white_banner": "bel prapor",
  "block.minecraft.orange_banner": "oranžen prapor",
  "block.minecraft.magenta_banner": "škrlaten prapor",
  "block.minecraft.light_blue_banner": "svetlo moder prapor",
  "block.minecraft.yellow_banner": "rumen prapor",
  "block.minecraft.lime_banner": "svetlo zelen prapor",
  "block.minecraft.pink_banner": "roza prapor",
  "block.minecraft.gray_banner": "siv prapor",
  "block.minecraft.light_gray_banner": "svetlo siv prapor",
  "block.minecraft.cyan_banner": "turkizen prapor",
  "block.minecraft.purple_banner": "vijoličen prapor",
  "block.minecraft.blue_banner": "moder prapor",
  "block.minecraft.brown_banner": "rjav prapor",
  "block.minecraft.green_banner": "zelen prapor",
  "block.minecraft.red_banner": "rdeč prapor",
  "block.minecraft.black_banner": "črn prapor",
  "item.minecraft.end_crystal": "end kristal",
  "item.minecraft.chorus_fruit": "refrensko sadje",
  "item.minecraft.popped_chorus_fruit": "izstreljeno refrensko sadje",
  "item.minecraft.beetroot": "rdeča pesa",
  "item.minecraft.beetroot_seeds": "pesina semena",
  "item.minecraft.beetroot_soup": "pesina juha",
  "item.minecraft.dragon_breath": "zmajev dih",
  "item.minecraft.splash_potion": "škropilni neustvarljiv napoj□brez učinkov",
  "item.minecraft.spectral_arrow": "fantomska puščica",
  "item.minecraft.tipped_arrow": "neustvarljiva strupena puščica□brez učinkov",
  "item.minecraft.lingering_potion": "neustvarljiv dolgotrajen napoj□brez učinkov",
  "item.minecraft.shield": "ščit",
  "item.minecraft.elytra": "elitra",
  "item.minecraft.spruce_boat": "smrekov čoln",
  "item.minecraft.birch_boat": "brezov čoln",
  "item.minecraft.jungle_boat": "džungelski čoln",
  "item.minecraft.acacia_boat": "akacijev čoln",
  "item.minecraft.dark_oak_boat": "temen hrastov čoln",
  "item.minecraft.totem_of_undying": "totem neumiranja",
  "item.minecraft.shulker_shell": "shulkerjev oklep",
  "item.minecraft.iron_nugget": "železno zrno",
  "item.minecraft.knowledge_book": "knjiga znanja",
  "item.minecraft.debug_stick": "razvijalčeva palica",
  "item.minecraft.music_disc_13": "glasbena plošča□c418 - 13",
  "item.minecraft.music_disc_cat": "glasbena plošča□c418 - cat",
  "item.minecraft.music_disc_blocks": "glasbena plošča□c418 - blocks",
  "item.minecraft.music_disc_chirp": "glasbena plošča□c418 - chirp",
  "item.minecraft.music_disc_far": "glasbena plošča□c418 - far",
  "item.minecraft.music_disc_mall": "glasbena plošča□c418 - mall",
  "item.minecraft.music_disc_mellohi": "glasbena plošča□c418 - mellohi",
  "item.minecraft.music_disc_stal": "glasbena plošča□c418 - stal",
  "item.minecraft.music_disc_strad": "glasbena plošča□c418 - strad",
  "item.minecraft.music_disc_ward": "glasbena plošča□c418 - ward",
  "item.minecraft.music_disc_11": "glasbena plošča□c418 - 11",
  "item.minecraft.music_disc_wait": "glasbena plošča□c418 - wait",
  "item.minecraft.music_disc_pigstep": "glasbena plošča□lena raine - pigstep",
  "item.minecraft.trident": "trizob□□kadar v primarni roki:□+8 škoda napada□-2.9 hitrost napada",
  "item.minecraft.phantom_membrane": "fantomova membrana",
  "item.minecraft.nautilus_shell": "drobnikova lupina",
  "item.minecraft.heart_of_the_sea": "srce morja",
  "item.minecraft.crossbow": "samostrel",
  "item.minecraft.suspicious_stew": "sumljiva juha",
  "block.minecraft.loom": "statve",
  "item.minecraft.flower_banner_pattern": "vzorec za zastave□roža",
  "item.minecraft.creeper_banner_pattern": "vzorec za zastave□creeper",
  "item.minecraft.skull_banner_pattern": "vzorec za zastave□gusarski znak",
  "item.minecraft.mojang_banner_pattern": "vzorec za zastave□stvar",
  "item.minecraft.globe_banner_pattern": "vzorec za zastave□globus",
  "item.minecraft.piglin_banner_pattern": "vzorec za zastave□rilec",
  "block.minecraft.composter": "kompostnik",
  "block.minecraft.barrel": "sod",
  "block.minecraft.smoker": "prekajevalnik",
  "block.minecraft.blast_furnace": "plavž",
  "block.minecraft.cartography_table": "kartografska miza",
  "block.minecraft.fletching_table": "miza za izdelavo puščic",
  "block.minecraft.grindstone": "brusni kamen",
  "block.minecraft.lectern": "stojalo za knjigo",
  "block.minecraft.smithing_table": "orodjarjeva miza",
  "block.minecraft.stonecutter": "rezalnik kamna",
  "block.minecraft.bell": "zvonec",
  "block.minecraft.lantern": "svetilka",
  "block.minecraft.soul_lantern": "svetila duše",
  "item.minecraft.sweet_berries": "sladke jagode",
  "block.minecraft.campfire": "taborni ogenj",
  "block.minecraft.soul_campfire": "taborni ogenj duš",
  "block.minecraft.shroomlight": "gobanova luč",
  "item.minecraft.honeycomb": "satje",
  "block.minecraft.bee_nest": "čebelje gnezdo",
  "block.minecraft.beehive": "panj",
  "item.minecraft.honey_bottle": "steklenica medu",
  "block.minecraft.honey_block": "kocka medu",
  "block.minecraft.honeycomb_block": "kocka satja",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "kocka netherita",
  "block.minecraft.ancient_debris": "starodavne razbitine",
  "block.minecraft.target": "tarča",
  "block.minecraft.crying_obsidian": "jokajoči vulkanski kamen",
  "block.minecraft.blackstone": "črni kamen",
  "block.minecraft.blackstone_slab": "črna kamnita plošča",
  "block.minecraft.blackstone_stairs": "črne kamnite stopnice",
  "block.minecraft.gilded_blackstone": "pozlačen črni kamen",
  "block.minecraft.polished_blackstone": "brušen črni kamen",
  "block.minecraft.polished_blackstone_slab": "brušena črna kamnita plošča",
  "block.minecraft.polished_blackstone_stairs": "brušene črne kamnite stopnice",
  "block.minecraft.chiseled_polished_blackstone": "izklesan brušen črni kamen",
  "block.minecraft.polished_blackstone_bricks": "brušene črne kamnite opeke",
  "block.minecraft.polished_blackstone_brick_slab": "brušena črna kamnita opečnata plošča",
  "block.minecraft.polished_blackstone_brick_stairs": "brušene črne kamnite opečnate stopnice",
  "block.minecraft.cracked_polished_blackstone_bricks": "razpokane brušene črne kamnite opeke",
  "block.minecraft.respawn_anchor": "sidro ponovnega življenja",
}
export const sl_si = items; 
